export function toggleMobile(event) {
    event.preventDefault();
    let $manageCartFilter = $('.manageCart__filters');
    $manageCartFilter.toggle();
}

function initEventHandlers() {
    let $plpFilterMobileToggle = $('.manageCart__mobile-toggle');
    $plpFilterMobileToggle.on('click', toggleMobile);

    let $manageCartFilterMobileToggle = $('.manageCart__filter-toggle');
    $manageCartFilterMobileToggle.on('click', toggleMobile);
}

$(function () {
    initEventHandlers();
});
